(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["esime-motion"] && !Shopify.designMode) return;
  try {
    (async () => {
  const { getScrollEventTarget, getScrollTop, scrollTo: scrollPageTo, scrollContainerMediaQuery, getIntersectionRoot } = await import('@theme/scroll-container');
  if (!customElements.get('esime-motion')) {
    const clamp = (value) => Math.max(0, Math.min(1, value));
    const smooth = (start, end, value) => {
      const p = clamp((value - start) / (end - start));
      return p * p * (3 - 2 * p);
    };

    class EsimeMotion extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.compact = matchMedia('(max-width: 760px)');
        this.frame = 0;
        this.parts = new Map();
        this.querySelectorAll('[class]').forEach((element) => {
          element.classList.forEach((name) => {
            if (!this.parts.has(name)) this.parts.set(name, []);
            this.parts.get(name).push(element);
          });
        });
        const signal = this.controller.signal;
        if (this.dataset.scene !== 'setup') {
          this.bindScroll();
          scrollContainerMediaQuery.addEventListener('change', this.bindScroll, { signal });
          addEventListener('resize', this.requestUpdate, { passive: true, signal });
          this.reduced.addEventListener('change', this.requestUpdate, { signal });
        }
        this.addEventListener('click', this.handleClick, { signal });
        this.addEventListener('keydown', this.handleKeydown, { signal });
        this.observeReveals();
        const steps = this.one('ep-all-steps-details');
        if (steps) steps.open = this.compact.matches || (this.reduced.matches || this.dataset.motionEnabled === 'false');
        this.update();
      }

      observeReveals() {
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-shown');
                this.observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1, root: getIntersectionRoot() },
        );
        this.all('ep-reveal').forEach((element) => this.observer.observe(element));
      }

      bindScroll = () => {
        this.scrollTarget?.removeEventListener('scroll', this.requestUpdate);
        this.scrollTarget = getScrollEventTarget();
        this.scrollTarget.addEventListener('scroll', this.requestUpdate, { passive: true, signal: this.controller.signal });
        if (this.observer) this.observeReveals();
        this.requestUpdate();
      };

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      one(name) {
        return this.parts.get(name)?.[0];
      }
      all(name) {
        return this.parts.get(name) || [];
      }
      paint(element, values) {
        if (element) Object.assign(element.style, values);
      }
      requestUpdate = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };

      progress(track, stage) {
        const top = parseFloat(getComputedStyle(stage).top) || 0;
        return clamp((top - track.getBoundingClientRect().top) / Math.max(1, track.offsetHeight - stage.offsetHeight));
      }

      update = () => {
        this.frame = 0;
        if (!this.isConnected) return;
        const kind = this.dataset.scene;
        if (kind === 'hero') this.updateHero();
        if (kind === 'europe') this.updateEurope();
        if (kind === 'product') this.updateProduct();
        if (kind === 'footer') this.updateFooter();
      };

      updateHero() {
        const p = this.progress(this, this.one('hero-stage'));
        const reduced = (this.reduced.matches || this.dataset.motionEnabled === 'false');
        const exit = reduced ? 0 : smooth(0.26, 0.56, p);
        const enter = reduced ? 1 : smooth(0.36, 0.58, p);
        this.paint(this.one('hero-stage__intro'), {
          opacity: 1 - exit,
          filter: `blur(${exit * 5}px)`,
          transform: `translate3d(0,${-exit * 86}px,0)`,
        });
        this.one('hero-stage__intro').setAttribute('aria-hidden', !reduced && exit > 0.78);
        this.paint(this.one('hero-stage__promise'), { opacity: enter });
        this.one('hero-stage__promise').setAttribute('aria-hidden', !reduced && enter < 0.22);
        this.one('hero-stage__promise').inert = !reduced && enter < 0.22;
        const promise = this.one('hero-stage__promise');
        const cta = this.one('hero-promise-cta');
        if (cta) {
          const heading = promise.querySelector('h2').getBoundingClientRect();
          cta.style.top = `${heading.bottom - promise.getBoundingClientRect().top + 20}px`;
        }
        this.all('hero-reveal-word').forEach((word, i, words) => {
          const start = (i / (words.length + 2)) * 0.78;
          const v = reduced ? 1 : smooth(start, Math.min(1, start + 0.24), clamp((p - 0.39) / 0.48));
          this.paint(word, { opacity: v, filter: `blur(${(1 - v) * 5}px)` });
        });
        const phone = this.one('hero-stage__phone');
        const travel = innerWidth <= 760 ? 0 : innerWidth <= 1100 ? 18 : 34;
        const phoneProgress = reduced ? 0 : smooth(0.12, 0.82, p);
        phone.style.setProperty('--hero-phone-x', `${phoneProgress * travel}vw`);
        phone.style.setProperty('--hero-phone-y', `${phoneProgress * 150}px`);
        this.paint(this.one('phone-ui--0'), { opacity: reduced ? 1 : 1 - smooth(0.36, 0.44, p) });
        this.paint(this.one('phone-ui--1'), { opacity: reduced ? 0 : smooth(0.46, 0.56, p) });
      }

      updateEurope() {
        const stage = this.one('europe-stage');
        const p = this.progress(this, stage);
        const reduced = (this.reduced.matches || this.dataset.motionEnabled === 'false');
        const exit = reduced ? 0 : smooth(0.56, 0.72, p);
        const enter = reduced ? 1 : smooth(0.61, 0.81, p);
        const popular = this.one('europe-popular');
        this.paint(popular, {
          opacity: 1 - exit,
          filter: `blur(${exit * 6}px)`,
          transform: `translate3d(0,${-exit * 32}px,0)`,
        });
        popular.setAttribute('aria-hidden', !reduced && exit > 0.82);
        popular.inert = !reduced && exit > 0.82;
        this.one('europe-quiet').setAttribute('aria-hidden', !reduced && enter < 0.22);
        this.one('europe-quiet').inert = !reduced && enter < 0.22;
        const title = this.one('europe-popular__statement');
        const stageRect = stage.getBoundingClientRect();
        const eyebrow = this.one('europe-popular__eyebrow');
        const factor = this.dataset.gapUnit === 'percent' ? stage.offsetHeight / 100 : 1;
        const initialGap = Math.max(0, Number(this.dataset.gapStart ?? 25)) * factor;
        const finalGap = Math.min(initialGap, Math.max(0, Number(this.dataset.gapEnd ?? 6)) * factor);
        const gap = initialGap + (finalGap - initialGap) * (reduced ? 1 : smooth(0.025, 0.11, p));
        const titleY = eyebrow.offsetTop + eyebrow.offsetHeight + gap;
        const titleTop = stageRect.top + titleY;
        title.style.top = `${titleY}px`;
        const opacity = reduced ? 1 : smooth(0, title.offsetHeight + innerHeight * 0.12, innerHeight - titleTop);
        this.paint(title, {
          opacity,
          transform: `translateX(-50%)`,
        });
        const top = parseFloat(getComputedStyle(stage).top) || 0;
        const approach = smooth(0, Math.max(1, innerHeight * 0.55 - top), innerHeight * 0.55 - stageRect.top);
        this.paint(this.one('europe-popular__eyebrow'), { top: `${approach * (this.compact.matches ? 36 : 54)}px` });
        this.all('europe-landmark-card').forEach((card, i) => {
          const column = i % 3;
          const row = Math.floor(i / 3);
          const stagger = [30, 70, 0][column] * (this.compact.matches ? 0.5 : 1);
          const offset = stagger + row * (card.offsetHeight + (this.compact.matches ? 20 : 40));
          const y = offset - clamp((p + 0.08) / 0.72) * (stage.offsetHeight + Math.max(this.compact.matches ? 145 : 220, card.offsetHeight + 40));
          this.paint(card, { transform: reduced ? 'none' : `translate3d(0,${y}px,0)` });
        });
        this.paint(this.one('europe-quiet__heading'), {
          opacity: enter,
          transform: `translate3d(0,${(1 - enter) * 32}px,0)`,
        });
        this.all('europe-quiet-card').forEach((card, i) => {
          const v = reduced ? 1 : smooth(0.63 + i * 0.012, 0.88 + i * 0.012, p);
          this.paint(card, {
            opacity: v,
            filter: `blur(${(1 - v) * 2}px)`,
            transform: `translate3d(0,${(1 - v) * 38}px,0)`,
          });
        });
      }

      updateProduct() {
        const track = this.one('ep-scene-track');
        const simple = this.compact.matches || (this.reduced.matches || this.dataset.motionEnabled === 'false');
        this.one('ep-activation').classList.toggle('ep-activation--simple', simple);
        const p = clamp(-track.getBoundingClientRect().top / Math.max(1, track.offsetHeight - innerHeight));
        const phase = simple ? 0 : smooth(0.43, 0.65, p);
        this.querySelectorAll('[data-phase-label]').forEach((label, i) => (label.hidden = i !== Number(phase >= 0.5)));
        this.all('ep-scene-word').forEach((word, i) =>
          this.paint(word, {
            opacity: i ? phase : 1 - phase,
            transform: `translateY(${i ? (1 - phase) * 25 : -phase * 25}px)`,
          }),
        );
        this.paint(this.one('ep-scene-phone'), {
          transform: `translate(calc(-50% + ${phase * 15}vw),-50%) rotate(${(1 - phase) * -5}deg)`,
        });
        this.all('ep-screen-panel').forEach((panel, i) => {
          this.paint(panel, { opacity: i ? phase : 1 - phase });
          panel.setAttribute('aria-hidden', i ? phase <= 0.5 : phase > 0.5);
        });
        this.all('ep-scene-cards').forEach((cards, i) => {
          this.paint(cards, {
            opacity: i ? phase : 1 - phase,
            pointerEvents: 'none',
            transform: `translateY(${i ? (1 - phase) * 38 : -phase * 38}px)`,
          });
          cards.setAttribute('aria-hidden', i ? phase < 0.5 : phase >= 0.5);
        });
        const active = p < 0.25 ? 0 : p < 0.52 ? 1 : p < 0.78 ? 2 : 3;
        this.querySelectorAll('[data-step]').forEach((button, i) =>
          i === active ? button.setAttribute('aria-current', 'step') : button.removeAttribute('aria-current'),
        );
        if (simple) {
          if (this.one('ep-all-steps-details')) this.one('ep-all-steps-details').open = true;
          this.all('ep-reveal').forEach((element) => element.classList.add('is-shown'));
        }
      }

      updateFooter() {
        const start = innerHeight * 0.96;
        const end = Math.max(innerHeight * 0.54, innerHeight - this.offsetHeight);
        const p = (this.reduced.matches || this.dataset.motionEnabled === 'false')
          ? 1
          : clamp((start - this.getBoundingClientRect().top) / Math.max(1, start - end));
        this.paint(this.one('footer-wordmark'), {
          opacity: 0.08 + p * 0.92,
          transform: `perspective(1100px) translate3d(0,${(1 - p) * 140}px,0) rotateX(${(1 - p) * 78}deg) scaleY(${0.82 + p * 0.18})`,
        });
      }

      selectTab(index, focus = false) {
        this.querySelectorAll('[data-setup-tab]').forEach((button, i) => {
          const active = i === index;
          button.setAttribute('aria-selected', active);
          button.tabIndex = active ? 0 : -1;
          button.classList.toggle('setup-tab--active', active);
          if (active && focus) button.focus();
        });
        this.querySelectorAll('[data-setup-panel]').forEach((panel, i) => (panel.hidden = i !== index));
      }

      handleKeydown = (event) => {
        const tab = event.target.closest('[data-setup-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.selectTab(event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - Number(tab.dataset.setupTab), true);
      };

      handleClick = (event) => {
        const button = event.target.closest('[data-setup-tab],[data-step],[data-skip-animation],[data-choose-plan]');
        if (!button) return;
        const behavior = (this.reduced.matches || this.dataset.motionEnabled === 'false') ? 'instant' : 'smooth';
        if (button.hasAttribute('data-setup-tab')) this.selectTab(Number(button.dataset.setupTab));
        if (button.hasAttribute('data-step')) {
          const track = this.one('ep-scene-track');
          scrollPageTo({
            top:
              getScrollTop() +
              track.getBoundingClientRect().top +
              (track.offsetHeight - innerHeight) * [0.12, 0.34, 0.7, 0.9][Number(button.dataset.step)],
            behavior,
          });
        }
        if (button.hasAttribute('data-skip-animation'))
          this.one('ep-activation-bottom').scrollIntoView({ behavior, block: 'start' });
        if (button.hasAttribute('data-choose-plan')) {
          event.preventDefault();
          document.querySelector('.product-information')?.scrollIntoView({ behavior, block: 'start' });
        }
      };
    }
    customElements.define('esime-motion', EsimeMotion);
  }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esime-usa-price-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('esime-plan-prices')) {
    customElements.define('esime-plan-prices', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const choose = (tab) => {
          if (!tab || tab.disabled) return;
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            this.querySelector(`#${CSS.escape(item.getAttribute('aria-controls'))}`).hidden = !active;
          });
        };
        this.addEventListener('click', event => choose(event.target.closest('[role="tab"]')), {signal:this.controller.signal});
        this.addEventListener('keydown', event => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const enabled = tabs.filter(item => !item.disabled);
          let index = enabled.indexOf(tab);
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = enabled.length - 1;
          else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + enabled.length) % enabled.length;
          choose(enabled[index]); enabled[index]?.focus();
        }, {signal:this.controller.signal});
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
